<template>
  <div id="warranty_list" style="position: relative;">
    <van-nav-bar
      title="订单列表"
      left-text="返回"
      right-text="新建订单"
      left-arrow
      @click-left="onClickLeft"
      @click-right="createOrder"
    />
    <div style="position: relative;overflow: hidden;">
      <van-dropdown-menu>
        <van-dropdown-item v-model="checkStatus" :options="statusOptions" @change="changeStatus" />
        <van-dropdown-item v-model="value2" :options="option2" @change="changeSort" />
        <div style="position: absolute; right: 20px; top: 10px; width: 80px;" @click="showSearch">
          <van-icon name="filter-o"  />筛选
        </div>
      </van-dropdown-menu>
    </div>
    <!--<div class="search_content" style="overflow: hidden; background-color: #FFFFFF; min-height: 30px; width: 100%; margin-bottom: 2px; padding-top: 5px;">
      <div class="search_item" style="float: left;background-color: #f6f6f6; border-radius: 10px;padding-left: 10px; padding-right: 10px; margin-left: 20px;">
        <div style="float: left; text-align: center; font-size: 15px; color: #666666; ">品牌</div>
        <div style="float: left; width: 10px;">
          <img src="@/assets/arrow_down.png" style="width: 10px; height: 10px;object-fit: contain" />
        </div>
      </div>
      <div class="search_item" style="float: left;background-color: #f6f6f6; border-radius: 10px;padding-left: 10px; padding-right: 10px; margin-left: 20px;">
        <div style="float: left; text-align: center; font-size: 15px; color: #666666; ">城市</div>
        <div style="float: left; width: 10px;">
          <img src="@/assets/arrow_down.png" style="width: 10px; height: 10px;object-fit: contain" />
        </div>
      </div>
    </div>
    <div style="position: absolute; z-index: 1000;">
      <div style="background-color: #f6f6f6;height: 100px;width: 100vw;">
      </div>
      <div style="background-color: #FFFFFF;">
        <div style="float: left; color: #FFFFFF; width: 40%; height: 30px; line-height: 30px; margin-left: 10%; background-color: #EFB750; font-size: 12px; border-top-left-radius: 12px; border-bottom-left-radius: 12px;">重置</div>
        <div style="float: left; color: #FFFFFF; width: 40%; height: 30px; line-height: 30px; margin-right: 10%; background-color: #E76E3B; font-size: 12px; border-top-right-radius: 12px; border-bottom-right-radius: 12px;">确定</div>
      </div>
    </div>-->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="list-item" @click="showReport(item.id, item)">
        <div class="item-left">
          <img v-if="item.file_url_thumb" :src="item.file_url_thumb" class="item-left-image" />
          <img v-else src="@/assets/default.png" alt="img" class="item-left-image" />
        </div>
        <div class="item-right">
          <div class="item-right-time">订单编号 : {{ item.supplier_order_no }}</div>
          <div class="item-right-header">
            <div class="item-right-type">{{ item.ma_type_cn }}</div>
            <div class="item-right-status" v-if="item.status_value">
              <van-tag v-if="item.status_color === 'blue'" round type="primary">{{ item.status_value }}</van-tag>
              <van-tag v-else-if="item.status_color === 'yellow'" round type="warning">{{ item.status_value }}</van-tag>
              <van-tag v-else-if="item.status_color === 'red'" round type="danger">{{ item.status_value }}</van-tag>
              <van-tag v-else-if="item.status_color === 'green'" round type="success">{{ item.status_value }}</van-tag>
              <van-tag v-else round type="warning">{{ item.status_value }}</van-tag>
            </div>
          </div>
          <div class="item-right-time">品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;牌 : {{ item.brand_en }}</div>
          <div class="item-right-time">店&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;铺 : {{ item.store_name_cn }}</div>
          <div class="item-right-time">维修项目 : {{ item.ma_item_cate_cn }}</div>
          <div class="item-right-time" v-if="item.ma_start_to_end">维修时间 : {{ item.ma_start_to_end }}</div>
        </div>
      </div>
    </van-list>
    <van-popup v-model:show="show" position="right" :style="{ width: '70%', height: '100%' }">
      <div style="text-align: left;padding: 20px;">查询</div>
      <el-form label-position="left" label-width="60px" style="width: 94%; margin: 10px auto;">
        <el-form-item label="品牌：" prop="brand_id">
          <el-select v-model="addForm.brand_id" placeholder="请选择" filterable clearable class="form-item-width" @change="syncShops">
            <el-option v-for="(v, k) in brandsList" :key="k" :value="v.id" :label="v.brand_en" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市：" prop="brand_id">
          <el-select v-model="addForm.city_id"  placeholder="请选择" filterable clearable class="form-item-width" @change="syncData">
            <el-option v-for="(v, k) in cityList" :key="k" :value="v.id" :label="v.city_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="商场：" prop="market_id">
          <el-select v-model="addForm.market_id" :allow-create="true" placeholder="支持输入" filterable class="form-item-width" @change="syncShops">
            <el-option v-for="(v, k) in marketList" :key="k" :value="v.id" :label="v.market_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺：" prop="store_id">
          <el-select v-model="addForm.store_id" placeholder="请选择" filterable class="form-item-width">
            <el-option v-for="v in storeList" :key="v.id" :value="v.id" :label="v.name_cn" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!--<van-form validate-first @failed="onFailed" style="margin-bottom: 20px">
        <van-field
          clickable
          name="picker"
          :value="addForm.city_name"
          label="城市"
          placeholder="城市"
          clearable
          @click="showCityPicker = true"
        />
        <van-popup v-model="showCityPicker" position="bottom">
          <van-picker
            title="请选择城市"
            show-toolbar
            :columns="cityList"
            value-key="city_cn"
            @confirm="onConfirmCity"
            @cancel="onCancelCity"
            @change="onChangeCity"
            :default-index="addForm.city_id"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.brand_name"
          label="品牌"
          placeholder="品牌"
          clearable
          @click="showBrandPicker = true"
        />
        <van-popup v-model="showBrandPicker" position="bottom">
          <van-picker
            title="请选择品牌"
            show-toolbar
            :columns="brandsList"
            value-key="brand_en"
            @confirm="onConfirmBrand"
            @cancel="onCancelBrand"
            @change="onChangeBrand"
            :default-index="addForm.brand_id"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.market_name"
          label="商场"
          placeholder="商场"
          clearable
          @click="showMarketPicker = true"
        />
        <van-popup v-model="showMarketPicker" position="bottom">
          <van-picker
            title="请选择商场"
            show-toolbar
            :columns="marketList"
            value-key="market_cn"
            @confirm="onConfirmMarket"
            @cancel="onCancelMarket"
            @change="onChangeMarket"
            :default-index="addForm.market_id"
          />
        </van-popup>
        <van-field
          v-model="addForm.shop_name"
          name="店铺名"
          label="店铺名"
          placeholder="店铺名"
          readonly
          @click="showStorePicker = true"
        />
        <van-popup v-model="showStorePicker" position="bottom">
          <van-picker
            title="请选择店铺名"
            show-toolbar
            :columns="storeList"
            value-key="name_cn"
            @confirm="onConfirmStore"
            @cancel="onCancelStore"
            @change="onChangeStore"
            :default-index="addForm.shop_id"
          />
        </van-popup>
        <van-button type="info" @click="onSubmit" style="margin-top: 30px;margin-bottom:10px; width: 30%;">搜索</van-button>
        <van-button type="primary" @click="returnBack" style="margin-top: 30px;width: 30%;margin-left: 10%;">返回</van-button>
      </van-form>-->
    </van-popup>
  </div>
</template>

<script>
import {getBrandList, getCityList, getMarketList, getOrderList, getOrderStatusList, getShopList} from '../../api/order'

const STATUS = ['', '待接受', '已提交', '待维修', '已完工', '待验收', '验收通过', '待返工']

export default {
  name: 'warranty_list',
  data () {
    return {
      value2: '',
      active: 0,
      list: [],
      tabTypes: ['全部', '待审批', '待维修', '已拒绝'],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      page: 0,
      categories: [],
      status: '',
      statusOptions: [],
      brandsList: [],
      defaultIcon: '@/assets/default.png',
      option2: [
        { text: '默认排序', value: '' },
        { text: '创建时间降序', value: 'desc' },
        { text: '创建时间升序', value: 'asc' }
      ],
      checkStatus: '',
      show: false,
      addForm: {
        city_id: '',
        market_id: '',
        brand_id: ''
      },
      storeList: [],
      marketList: [],
      cityList: [],
      showMarketPicker: false,
      showCompanyPicker: false,
      showBrandPicker: false,
      showStorePicker: false,
      showCityPicker: false,
      loadingStatus: false,
    }
  },
  created () {
    if (typeof this.$route.query.status !== 'undefined') {
      this.checkStatus = this.$route.query.status
    }
    this.getOptions()
  },
  methods: {
    createOrder() {
      this.$router.push({path: '/order_create'})
    },
    returnBack() {
      this.show = false
    },
    syncShops() {
      this.searchStore()
    },
    async syncData() {
      this.addForm.store_id = ''
      this.addForm.market_id = ''
      await this.initMarkets(this.addForm.city_id)
      this.searchStore()
    },
    async getOptions() {
      await getOrderStatusList().then((res) => {
        if (res.data.data) {
          this.statusOptions = []
          for (const i in res.data.data) {
            this.statusOptions.push({
              text: res.data.data[i].v === '全部' ? '所有状态' : res.data.data[i].v,
              value: res.data.data[i].k
            })
          }
        }
      })
    },
    async initList (status = '', sort = '') {
      console.log('1111111111111111111111111111')
      console.log('jflksdjflkdsklf,status....', this.loadingStatus)
      if (this.loadingStatus) {
        return
      }
      let queryData = {page: this.page, is_leader: 1}
      if (status !== '' && typeof status !== 'undefined') {
        queryData.status = status
      } else if (this.$route.query && this.$route.query.status) {
        this.list = []
        queryData.status = this.$route.query.status
      }
      if (queryData.status === 'all') {
        queryData.status = ''
      }
      if (sort !== '') {
        queryData.sort = sort
      }
      if (this.addForm.city_id) {
        queryData.city_id = this.addForm.city_id
      }
      if (this.addForm.market_id) {
        queryData.market_id = this.addForm.market_id
      }
      if (this.addForm.brand_id) {
        queryData.brand_id = this.addForm.brand_id
      }
      if (this.finished === true) {
        return false
      }
      this.loading = true
      this.loadingStatus = true
      await getOrderList(queryData).then((res) => {
        console.log('res...................', res.data.data)
        if (res.data.data.list.length < 20) {
          this.finished = true
        }
        if (res.data.data.list) {
          this.list.push(...res.data.data.list)
        } else {
          this.finished = true
          this.list = []
        }
        this.loading = false
        this.loadingStatus = false
      })
    },
    onLoad () {
      setTimeout(() => {
        if (this.finished) {
          return false
        }
        if (this.loadingStatus) {
          return false
        }
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }
        this.initList()
        this.page++
        this.loading = false
      }, 1000)
    },
    onRefresh () {
      if (this.finished) {
        return false
      }
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      this.onLoad()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
    },
    showReport (id, val) {
      console.log('val........', val)
      this.$router.push({path:'/warranty_detail', query: {id: id, annex_id: val.annex_id, ma_item_id: val.ma_item_id, order_worker_id: val.order_worker_id, appo_task_id: val.appo_task_id}})
    },
    changeTypes (index) {
      this.active = index
      let status = ''
      if (index === 0) {
        status = ''
      } else if (index === 1) {
        status = 0
      } else if (index === 2) {
        status = 1
      } else if (index === 3) {
        status = 2
      }
      // 0已提交、1审批通过、2拒绝、3保存
      this.page = 1
      this.initList(status)
      this.list = []
    },
    changeStatus (val) {
      this.checkStatus = val
      this.list = []
      this.finished = false
      this.page = 1
      this.initList(val, this.value2)
    },
    changeSort (val) {
      this.value2 = val
      this.list = []
      this.finished = false
      this.page = 1
      this.initList(this.checkStatus, val)
    },
    showSearch() {
      this.show = true
      this.initCity()
      this.initBrand()
    },
    onCancelMarket() {
      this.showMarketPicker = false
    },
    onCancelStore() {
      this.showStorePicker = false
    },
    initCity() {
      getCityList().then((res) => {
        if (res.data.data) {
          this.cityList = res.data.data
        }
      })
    },
    initBrand() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brandsList = res.data.data
        }
      })
    },
    initMarkets() {
      getMarketList({city_id: this.addForm.city_id}).then((res) => {
        if (res.data.data) {
          this.marketList = res.data.data
        }
      })
    },
    onChangeStore() {

    },
    searchStore() {
      getShopList({city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id}).then((res) => {
        if (res.data.data) {
          this.storeList = res.data.data
        }
      })
    },
    onConfirmStore(evt) {
      this.addForm.shop_id = evt.id
      this.addForm.shop_name = evt.name_cn
      this.showStorePicker = false
      console.log('evt......', evt)
    },
    onConfirmCity(evt) {
      this.addForm.city_id = evt.id
      this.addForm.city_name = evt.city_cn
      this.showCityPicker = false
      this.initMarkets()
      this.searchStore()
    },
    onChangeCity(evt) {
      console.log(evt)
    },
    onCancelCity() {
      this.showCityPicker = false
    },
    onConfirmBrand(evt) {
      this.addForm.brand_id = evt.id
      this.addForm.brand_name = evt.brand_en
      this.showBrandPicker = false
      this.searchStore()
    },
    onConfirmMarket(evt) {
      this.addForm.market_id = evt.id
      this.addForm.market_name = evt.market_cn
      this.addForm.shop_id = ''
      this.addForm.shop_name = ''
      this.showMarketPicker = false
      this.searchStore()
    },
    onChangeMarket() {

    },
    onCancelBrand() {
      this.showBrandPicker = false
    },
    onFailed() {

    },
    onChangeBrand() {

    },
    onSubmit() {
      this.list = []
      this.page = 1
      this.initList(this.checkStatus, this.value2)
      this.show = false
      this.finished = false
    },
  }
}
</script>

<style>
.van-card__content {
  text-align: left;
}
.van-dropdown-menu__bar {
  width: 60% !important;
  padding-right: 40% !important;
}
.list-item {
  height: 90px;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 10px;
  background: #ffffff;
}
.list-show {
  background: #F5F5F5;
  min-height: calc(100vh - 100px);
}
.item-left, .item-right {
  float: left;
}
.item-left {
  width: 90px;
}
.item-right-status {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  width: auto;
  padding: 0 8px;
  margin-right: 8px;
  text-align: center;
  border-radius: 16px;
}
.item-right {
  width: calc(90% - 70px);
  font-size: 14px;
  margin-left: 10px;
  text-align: left;
}
.item-right-type {
  color: #000000;
  margin-right: 10px;
}
.item-right-status, .item-right-type {
  float: left;
}
.item-right-header {
  overflow: hidden;
}
.item-left-image {
  width: 90px;
  height: 90px;
  border-radius: 4px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/order/list.vue